const RESOLUTION_TYPES = {
  PHONE: 'PHONE',
  TABLET: 'TABLET',
  DESKTOP: 'DESKTOP',
  SMALL_DESKTOP: 'SMALL_DESKTOP',
};

export default RESOLUTION_TYPES;
